<template>
  <div class="links">
    <div class="title">友情<p />链接</div>
    <div class="body">
      <el-link type="info" v-for="item in content" :key="item.id" :href="item.link">{{ item.name }}</el-link>
    </div>
  </div>
</template>
<script>
import api from "../api/api";

export default ({
  name: "FriendLink",
  data() {
    return {
      content: null
    }
  },
  async mounted() {
    let json = await api.common.friendlink()
    this.content = json;
  }
})
</script>

<style scoped>
.links {
  height: 60px;
  border: 1px solid #BC0000;
}
.title {
  width: 60px;
  background: #BC0000;
  height: 24px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  line-height: 6px;
  letter-spacing: 6px;
  text-align: center;
  padding: 18px 0;
  float: left;
}
.body {
  width: 1100px;
  height: 60px;
  float: left;
  margin-left: 20px;
  line-height: 25px;
  display: flex;
  flex-direction: row;
  align-content: center;
  flex-wrap: wrap;
}
.el-link {
  margin-right: 10px;
}
</style>